import { render, staticRenderFns } from "./Loss-inventory.vue?vue&type=template&id=2c0aab82&scoped=true"
import script from "./Loss-inventory.vue?vue&type=script&lang=js"
export * from "./Loss-inventory.vue?vue&type=script&lang=js"
import style0 from "./Loss-inventory.vue?vue&type=style&index=0&id=2c0aab82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0aab82",
  null
  
)

export default component.exports